import React from 'react'
import { Input } from 'reactstrap'
import { hasIssuedAndExpirationDates } from '../DocumentModal/utils'

function DocumentDataInput({
    field,
    handleDriverDataChange,
}) {
    const hasIssuedExpirationDates = hasIssuedAndExpirationDates(field)
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    const maxDate = (["DATE_OF_BIRTH", "ISSUED_DATE", "ANTIQUITY"].includes(field.fieldCode))
        ? today.toISOString().split('T')[0]
        : undefined

    const minDate = (field.fieldCode === 'EXPIRATION_DATE')
        ? (hasIssuedExpirationDates
            ? new Date(today.getTime() + 86400000).toISOString().split('T')[0] // tomorrow
            : today.toISOString().split('T')[0])
        : undefined

    return (
        <div>
            <Input
                type={field.fieldType}
                name={field.fieldCode}
                value={field.value || ''}
                onChange={handleDriverDataChange}
                max={maxDate}
                min={minDate}
                invalid={Boolean(field.errorMessage)}
            />
            {(field.errorMessage) && (
                <small style={{ color: "red", fontSize: "12px" }}>
                    {field.errorMessage}
                </small>
            )}
        </div>
    )
}

export default DocumentDataInput
